import { createSlice } from '@reduxjs/toolkit'

export const SocketSlice = createSlice({
    name: 'socket',
    initialState: { socketConnection: null },
    reducers: {
      openSocket: (state, action) => {
        state.socketConnection = action.payload;
      },
      closeSocket: (state) => {
        if (state.socketConnection) {
          state.socketConnection.stop().catch((err) =>
            console.error("Error stopping SignalR connection:", err)
          );
        }
        state.socketConnection = null;
      },
    },
  });
  
  export const { openSocket, closeSocket } = SocketSlice.actions;
  export default SocketSlice.reducer;
  